module.exports = __webpack_public_path__ + "static/media/galeria3.f134b4f8.jpg";